import { QueryClient } from '@tanstack/react-query'
import { dataLayerPublish } from '@dhl/datalayer'

export const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
    mutations: {
      retry: 0,
      onError: (error) => {
        try {
          dataLayerPublish('ERROR', { id: 'react-query', error, message: error?.message, name: error?.name })
        } catch {
          //
        }
      },
    },
  },
})
